module.exports = __webpack_public_path__ + "img/live-chat-v2-img.e6a12ac2.svg";